// extracted by mini-css-extract-plugin
module.exports = {"towing_tab":"MobileUniversalSearchTowingVehicles_towing_tab__HkTdM"};